export enum ControlRxSubmissionType {
    New = 1,
    Revise = 2,
    Void = 3
}

export enum submissionStatusNotif {
    FTPBlank = 0,
    FTPFailed = 1,
    FTPSuccess = 2,
    PDMPPending = 0,
    PDMPFailed = 1,
    PDMPSuccess = 2
}
